import type {AnalyticsGenesisActions} from 'src/action-creators/analytics-genesis';
import type {
  ProductCatalogItem,
  SelectedProduct,
} from 'src/types/analytics-genesis';

import {
  RECEIVE_PRODUCT_CATALOG_LIST,
  RECEIVE_CURRENT_PRODUCT_LIST_ITEM,
} from 'src/action-creators/analytics-genesis';


export type State = {
  productCatalogList: Array<ProductCatalogItem>;
  currentProductListItem: SelectedProduct | null;
};

const initialState = {
  productCatalogList: [],
  currentProductListItem: null,
};

export default (
  state: State = initialState,
  action: AnalyticsGenesisActions,
): State => {
  switch (action.type) {
    case RECEIVE_PRODUCT_CATALOG_LIST: {
      return {
        ...state,
        productCatalogList: action.payload.productCatalogList,
      };
    }
    case RECEIVE_CURRENT_PRODUCT_LIST_ITEM: {
      return {
        ...state,
        currentProductListItem: action.payload.currentProductListItem,
      };
    }
  }

  return state;
};
